<bl-modal-content
  #content
  [title]="'出力項目の並び順設定'"
  [okButtonSetting]="okButtonSetting"
  [footerButtonType]="footerButtonType"
  (dismissEvent)="btnKeyDownEvent($event)"
>
  <div class="pattern-modal-contents" body dnd-sortable>
    <div class="condition-item">
      <span class="select-label">出力パターン</span>
      <span class="colon">:</span>
      <bl-select
        [items]="selectExportPatternItems"
        [value]="selectExportPatternCode"
        (changeEvent)="onChangePatternName($event)"
      ></bl-select>
    </div>
    <!-- 画面テキスト -->
    <div class="pattern-description">
      「ドラッグ＆ドロップ」または「Alt＋矢印キー」で並び替えができます。
    </div>
    <!-- 入出力項目選択 -->
    <div class="pattern-container">
      <ng-container *ngIf="isLoaded">
        <div class="pattern-table-header"><span>出力項目</span></div>
        <ng-container>
          <div class="pattern-sortable-container">
            <div class="pattern-sortable">
              <bl-sortable
                #blSortable
                *ngIf="outputExportPatternInfo"
                [items]="outputExportPatternInfo?.exportItemHeaderInfoList"
                [itemTemplate]="itemTemplate"
                [option]="{ placeholderItem: '' }"
                (changeEvent)="onChangeExportItemHeaderInfoList($event)"
              ></bl-sortable>
              <ng-template #itemTemplate let-item="item">
                <div class="column-output-name">
                  <span>{{ item.value.exportItemDispName }}</span>
                </div>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/export-modal/export-pattern-modal/export-pattern-modal.component.html